import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { FieldGroup, FieldTextarea, EditSidebar, ShortHead, ContractBarLoader } from '../../../contracts/Elements';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { AssemblySideBar } from '../../Elements';
import AfViewWrapper from '../../AirframeAssembly/components/AfViewWrapper';
import AfViewCard from '../../AirframeAssembly/components/AfViewCard';
import AfClaimInfo from '../../AirframeAssembly/components/AfClaimInfo';
import AfClaimPayout from '../../AirframeAssembly/components/AfClaimPayout';
import AddEditShopVisit from '../../AirframeAssembly/components/AddEditShopVisit';
import AddEditClaims from '../../AirframeAssembly/components/AddEditClaims';
import AddEditPayout from '../../AirframeAssembly/components/AddEditPayout';
import { lgShopVisitCrudAc, addEditLgShopVisitAc, lgClaimsListAc, lgClaimInfoCrudAc, addEditLgClaimAc, lgSVStatusAc, lgClaimStatusAc } from '../actionCreators';
import { TOGGLE_VIEW_EDIT, LG_SHOP_VISIT_CRUD, LG_CLAIM_CRUD, LG_PAYOUT_CRUD } from '../actions';
import { eventTypeAc, assetInfoAc } from '../../AirframeAssembly/actionCreators';
import { checkString } from '../../../../formValidator';
import RoleBasedAccess from '../../../../utils/RoleBasedAccess';
import { imgStoragePath, assetsType } from '../../../../constants';
import { ListLoader } from '../../../../shared';
import { getLocalStorageInfo } from '../../../../utils';
import { trackActivity } from '../../../../utils/mixpanel';
class LgView extends Component{
  constructor(props){
    super(props);
    this.state = {
      modal: false,
      shopVisitReason: '',
      claimModal:false,
      claim:'',
      error: {}
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }
  changeMsn =(evt) =>{
    let url = '/'+assetsType[evt.asset_type]+'/'+evt.slug+'/maintenance/'+(evt.asset_type == '1' ? 'landing-gears':'engines');
    browserHistory.push(url);
    this.props.params.type = evt.asset_type == '1' ? assetsType[evt.asset_type]: 'engine';
    this.props.params.aircraft_slug = evt.slug;
  }
  toggleClaim = (claim_id) => {
    if(claim_id != undefined){
      this.setState({
        claimModal: !this.state.claimModal,
        claim:claim_id
      });
    }
    else{
      this.setState({
        claimModal: !this.state.claimModal,
        claim:''
      });
    }
  }

  rejectClaim = (e) => {
    e.preventDefault();
    const validateNewInput = {
      shopVisitReason: checkString({value: this.state.shopVisitReason, required: true, minLength: '', maxLength: '', message: 'Please Enter Reason To Reject'})
    };
    if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === '' })) {
      this.props.changeClaimStatus(this.state.claim,{status:4, reason_for_rejection: this.state.shopVisitReason});
      this.toggleClaim();
    }else{
      this.setState({
        error: validateNewInput
      });
    }
  }

  updateSvReson = (e) => {
    let value = e.target.value;
    this.setState(prevState => ({
      ...prevState,
      shopVisitReason: value,
      error: {}
    }));
  }
  rejectSv = (e) => {
    e.preventDefault();
    const validateNewInput = {
      shopVisitReason: checkString({value: this.state.shopVisitReason, required: true, minLength: '', maxLength: '', message: 'Please Enter Reason To Reject'})
    };
    if (Object.keys(validateNewInput).every((k) => { return validateNewInput[k] === '' })) {
      this.props.changeSVStatus({status: 4, reason_for_rejection: this.state.shopVisitReason});
      this.toggle();
    }else{
      this.setState({
        error: validateNewInput
      });
    }
  }

  componentDidMount(){
    this.props.eventDetails();
    this.props.eventType();
    this.props.fetchAssetInfo();
    this.props.fetchClaims();
    trackActivity('Page Visited',{
      application_module: 'Maintenance',
      page_title: 'Major Assemblies APU',
      item_type: 'Event Detail'
    })
  }
  render(){
    const { error } = this.state;
    const { lgShopVisit, eventTypes, lgClaims,assetInfoObj, lgClaimInfo, lgPayoutInfo, lgLoader } = this.props;
    return(
      <div style={{marginLeft: '215px', marginTop: '94px'}}>
        { Object.keys(assetInfoObj).length ?
          <ShortHead contrAssetBasicInfo={assetInfoObj} changeMsn={this.changeMsn} headingText="Maintenance" />:<ContractBarLoader />
        }
        { lgLoader ? <ListLoader /> :null }
        <AssemblySideBar params={this.props.params} />
          <div className="assembly-view-layout" style={{padding: '0 15px', marginLeft: '60px'}}>
            {
              Object.keys(lgShopVisit.data).length ?
              <div>
                <AfViewWrapper shopVisit={lgShopVisit.data} backLink={'/' + this.props.params.type + '/' + this.props.params.aircraft_slug + '/maintenance/landing-gears'}>
                  <AfViewCard loader={lgLoader} changeSVStatus={this.props.changeSVStatus} editAssembly={this.props.editAssembly} shopVisit={lgShopVisit.data}  toggle={this.toggle}/>
                </AfViewWrapper>
                {
                  lgShopVisit.data.status.value == 3 ?
                  <div className="add-claims-section">
                    <div className="add-claim-cta">
                      {
                        getLocalStorageInfo() && getLocalStorageInfo().user && getLocalStorageInfo().user.permission && getLocalStorageInfo().user.permission.maintenance && getLocalStorageInfo().user.permission.maintenance.claims && (getLocalStorageInfo().user.permission.maintenance.claims.indexOf('C') !== -1 || getLocalStorageInfo().user.permission.maintenance.claims.indexOf('U') !== -1) ?
                        <h4>MR Claim</h4>
                        :null
                      }
                        {
                          getLocalStorageInfo() && getLocalStorageInfo().user && getLocalStorageInfo().user.permission && getLocalStorageInfo().user.permission.maintenance && getLocalStorageInfo().user.permission.maintenance.claims && (getLocalStorageInfo().user.permission.maintenance.claims.indexOf('C') !== -1 || getLocalStorageInfo().user.permission.maintenance.claims.indexOf('U') !== -1) ?
                          <button onClick={() => this.props.claimInfoCrud('add', {})} className="btn-primary add-new">+ Add Claim</button>
                          :null
                        }
                    </div>
                    {
                      lgClaims.map((claim,index) =>
                      <div key={index} className="card-body">
                        {
                          (claim.status.value == 1 ||  claim.status.value ==2) && getLocalStorageInfo() && getLocalStorageInfo().user && getLocalStorageInfo().user.permission && getLocalStorageInfo().user.permission.maintenance && getLocalStorageInfo().user.permission.maintenance.claims && (getLocalStorageInfo().user.permission.maintenance.claims.indexOf('C') !== -1 || getLocalStorageInfo().user.permission.maintenance.claims.indexOf('U') !== -1) ?
                          <span onClick={() => this.props.toggleClaimEditBar({type: 'edit', data: claim, flag: true})} className="edit-icon"><img src={imgStoragePath + "icon_editblock.png"} alt="icon" /></span>
                          :null
                        }
                        {
                          getLocalStorageInfo() && getLocalStorageInfo().user && getLocalStorageInfo().user.permission && getLocalStorageInfo().user.permission.maintenance && getLocalStorageInfo().user.permission.maintenance.claims && (getLocalStorageInfo().user.permission.maintenance.claims.indexOf('C') !== -1 || getLocalStorageInfo().user.permission.maintenance.claims.indexOf('U') !== -1) ?
                          <div className="shop-visit-status">
                            <ul className="list-inline">
                              {
                                claim.status.value == 1 ?
                                <li className="list-inline-item">
                                  <span>Claim is Submitted </span>
                                  <button disabled={lgLoader} onClick={() => {this.props.changeClaimStatus(claim.id, {status: 2}); trackActivity('Item Status Changed', { page_title: 'Major Assemblies LG', application_module: 'Maintenance',  item_type:'Claim', item_id:claim.id, status:'Move to Review' })}} className="btn-primary add-new">{lgLoader ? 'Processing...': 'Move to Review'}</button>
                                </li>:null
                              }
                              {
                                claim.status.value == 2 ?
                                <li className="list-inline-item">
                                  <span>Claim is Submitted </span>
                                  <button disabled={lgLoader} onClick={() => {this.props.changeClaimStatus(claim.id, {status: 3}); trackActivity('Item Status Changed', { page_title: 'Major Assemblies LG', application_module: 'Maintenance',  item_type:'Claim', item_id:claim.id, status:'Reject' })}} className="btn-primary add-new">{lgLoader ? 'Processing...': 'Approve' }</button>
                                  <button className="btn-primary add-new" onClick={() => {this.toggleClaim(claim.id); trackActivity('Item Status Changed', { page_title: 'Major Assemblies LG', application_module: 'Maintenance',  item_type:'Claim', item_id:claim.id, status:'Reject' })}}>Reject</button>
                                </li>:null
                              }
                            </ul>
                          </div>
                          :null
                        }
                        <div>
                          <AfClaimInfo claim={claim} />
                        </div>
                        {
                          claim.status.value == 3 && getLocalStorageInfo() && getLocalStorageInfo().user && getLocalStorageInfo().user.permission && getLocalStorageInfo().user.permission.maintenance && getLocalStorageInfo().user.permission.maintenance.claims && (getLocalStorageInfo().user.permission.maintenance.claims.indexOf('C') !== -1 || getLocalStorageInfo().user.permission.maintenance.claims.indexOf('U') !== -1) ?
                          <div className="claim-payout-detail">
                            {
                              claim.payout_status.value == 1 ?
                              <span className="edit-icon" onClick={() => this.props.togglePayoutEditBar({type: 'edit', data: claim, flag: true})}><img src={imgStoragePath+"icon_editblock.png"} alt="icon" /></span>:null
                            }
                            <h4>Claim Payout Details</h4>
                            <div className="shop-visit-status">
                              <ul className="list-inline">
                              {
                                claim.payout_status.value == 1 ?
                                <li>
                                  <span>Claim Payout is Pending</span>
                                  <button
                                    disabled={!(claim.amount_paid > 0 && claim.amount_paid <= claim.claim_amount && claim.amount_paid != '')}
                                    className="btn-primary add-new"
                                    onClick={() => {this.props.changeClaimStatus(claim.id, {payout_status: 2}); trackActivity('Item Clicked', { page_title: 'Major Assemblies LG', application_module: 'Maintenance',  item_type:'Verify Amount', item_id:claim.id })}}>
                                    { lgLoader ? 'Processing...':'Verify Amount' }
                                  </button>
                                </li>
                                :null
                              }
                              {
                                claim.payout_status.value == 2 ?
                                <li>
                                  <span>Claim Payout Amount is Verified</span>
                                  <button
                                    disabled={!(claim.amount_paid > 0 && claim.amount_paid <= claim.claim_amount && claim.amount_paid != '')}
                                    className="btn-primary add-new"
                                    onClick={() => {this.props.changeClaimStatus(claim.id, {payout_status: 3}); trackActivity('Item Clicked', { page_title: 'Major Assemblies LG', application_module: 'Maintenance',  item_type:'Marked as Paid', item_id:claim.id })}}>
                                    {lgLoader ? 'Processing...':'Mark As Paid'}
                                  </button>
                                </li>
                                :null
                              }
                              </ul>
                            </div>
                            <AfClaimPayout claim={claim} />
                          </div>:null
                        }
                      </div>
                    )}
                  </div>:null
                }
                <EditSidebar
                  title={
                    lgShopVisit.type != '' ?
                    (lgShopVisit.type == 'add') ? 'Add Shop Visit for LG':
                    (lgShopVisit.type == 'edit') ? 'Edit Shop Visit for LG': 'View Shop Visit for LG' : ''
                    }
                  editSideBar={(lgShopVisit.flag && lgShopVisit.type == 'edit')}
                  toggleEditSideBar={() => this.props.toggleEditBar({type: '', data: lgShopVisit.data, flag: false})}
                  >
                  {
                    Object.keys(lgShopVisit.data).length && lgShopVisit.flag && lgShopVisit.type == 'edit' ?
                    <div>
                      <AddEditShopVisit
                        type={lgShopVisit.type}
                        shopVisitObj={lgShopVisit.data}
                        eventTypes={eventTypes}
                        addEditShopVisit={(data, type)=>this.props.addEditShopVisit(data, type, assetInfoObj)}
                        assemblyType="lg"
                        toggleEditSideBar={() => this.props.toggleEditBar({type: '', data: lgShopVisit.data, flag: false})}
                        loader={lgLoader}
                      />
                    </div>:null
                  }
                </EditSidebar>
                <EditSidebar
                  title={
                    lgClaimInfo.type != '' ?
                      (lgClaimInfo.type == 'add') ? 'Add Claim':
                      (lgClaimInfo.type == 'edit') ? 'Edit Claim': 'View Claim' : ''
                    }
                    toggleEditSideBar={() => this.props.toggleClaimEditBar({type: '', data: {}, flag: false})}
                    editSideBar={lgClaimInfo.flag}
                    loader={lgLoader}
                  >
                  {
                    Object.keys(lgClaimInfo.data).length && lgClaimInfo.flag ?
                    <div>
                      <AddEditClaims
                        type={lgClaimInfo.type}
                        claimObj={lgClaimInfo.data}
                        addEditClaims={(data, type)=>this.props.addEditClaims(data, type, assetInfoObj)}
                        assemblyType="lg"
                        toggleEditSideBar={() => this.props.toggleClaimEditBar({type: '', data: {}, flag: false})}
                        loader={lgLoader}
                        assetInfoObj={assetInfoObj}
                      />
                    </div>:null
                  }
                </EditSidebar>
                <EditSidebar
                  title="Edit Payout Detail"
                  toggleEditSideBar={() => this.props.togglePayoutEditBar({type: '', data: {}, flag: false})}
                  editSideBar={lgPayoutInfo.flag}
                  >
                  {
                    Object.keys(lgPayoutInfo.data).length && lgPayoutInfo.flag && lgPayoutInfo.type == 'edit' ?
                    <AddEditPayout
                      type="edit"
                      payoutObj={lgPayoutInfo.data}
                      addEditClaims={(data, type)=>this.props.addEditClaims(data, type, assetInfoObj)}
                      assemblyType="lg"
                      toggleEditSideBar={() => this.props.togglePayoutEditBar({type: '', data: {}, flag: false})}
                      loader={lgLoader}
                     />:null
                  }
                </EditSidebar>
              </div>:null
            }
          </div>
          <Modal isOpen={this.state.modal} toggle={this.toggle} className="sv-reject-modal">
            <ModalHeader toggle={this.toggle}>Reason For Rejection</ModalHeader>
            <ModalBody>
              <form onSubmit={(e) => this.rejectSv(e)}>
                <FieldGroup className="form-group">
                  <textarea onChange={this.updateSvReson}></textarea>
                  <h6 className="error-msg">{error.shopVisitReason}</h6>
                </FieldGroup>
                <input disabled={lgLoader} type="submit" className="btn-primary add-new" value={lgLoader ? 'Processing...': 'Save'} />
              </form>
            </ModalBody>
          </Modal>
          <Modal isOpen={this.state.claimModal} toggle={this.toggleClaim} className="sv-reject-modal">
            <ModalHeader toggle={this.toggleClaim}>Reason For Rejection</ModalHeader>
            <ModalBody>
              <form onSubmit={(e) => this.rejectClaim(e)}>
                <FieldGroup className="form-group">
                  <textarea onChange={this.updateSvReson}></textarea>
                  <h6 className="error-msg">{error.shopVisitReason}</h6>
                </FieldGroup>
                <input disabled={lgLoader} type="submit" className="btn-primary add-new" value={lgLoader ? 'Processing...': 'Save'} />
              </form>
            </ModalBody>
          </Modal>
      </div>
    )
  }
}
const mapStateToProps = (state, ownProps) => ({
  lgShopVisit: state.LangingGearAssemblyReducer.lgShopVisit,
  lgClaims: state.LangingGearAssemblyReducer.lgClaims,
  lgClaimInfo: state.LangingGearAssemblyReducer.lgClaimInfo,
  lgPayoutInfo: state.LangingGearAssemblyReducer.lgPayoutInfo,
  eventTypes: state.AirframeAssemblyReducer.eventTypes,
  assetInfoObj: state.AirframeAssemblyReducer.assetInfoObj,
  lgLoader: state.LangingGearAssemblyReducer.lgLoader
});

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchAssetInfo: () => dispatch(assetInfoAc(ownProps.params)),
    eventType: () => dispatch(eventTypeAc(ownProps.params, 'lg')),
    eventDetails: () => dispatch(lgShopVisitCrudAc(ownProps.params, 'view')),
    addEditShopVisit: (data, type, assetInfoObj) => dispatch(addEditLgShopVisitAc(ownProps.params, data, type, assetInfoObj)),
    fetchClaims: () => dispatch(lgClaimsListAc(ownProps.params, {shop_visit_id: ownProps.params.id})),
    addEditClaims: (data, type, assetInfoObj) => dispatch(addEditLgClaimAc(ownProps.params, data, type, assetInfoObj)),
    claimInfoCrud: (type, id) => dispatch(lgClaimInfoCrudAc(ownProps.params, type, id)),
    changeSVStatus: (data) => dispatch(lgSVStatusAc(ownProps.params, data)),
    changeClaimStatus: (id, data) => dispatch(lgClaimStatusAc(ownProps.params, id, data)),
    editAssembly: () => dispatch({
      type: TOGGLE_VIEW_EDIT,
      payload: ''
    }),
    toggleEditBar: (data) => dispatch({
      type: LG_SHOP_VISIT_CRUD,
      payload: data
    }),
    toggleClaimEditBar: (data) => dispatch({
      type: LG_CLAIM_CRUD,
      payload: data
    }),
    togglePayoutEditBar: (data) => dispatch({
      type: LG_PAYOUT_CRUD,
      payload: data
    })
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleBasedAccess(LgView, ['maintenance','landing_gears','R']));
